export const getLoading = (state) => state.offer.detail.loading;
export const getError = (state) =>  state.offer.detail.error;
export const getData = (state, offerId) =>  (state.offer.detail.data && state.offer.detail.data.id.toString() === offerId) ? state.offer.detail.data : null ;